import { withHandlers } from "reassemble";
export var withDOMNodeCallback = withHandlers(function () {
    var ref;
    return {
        onDOMNodeRef: function () { return function (e) {
            ref = e;
        }; },
        getDOMNode: function () { return function () { return ref; }; },
    };
});

//# sourceMappingURL=withDOMNodeCallback.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-css-transition/lib/composables/withDOMNodeCallback.js
// module id = 234
// module chunks = 0